import type { ValueOf } from 'type-fest';

const PREFIX = 'https://s.wink.co.kr/pc/renewalV3/subject';

export const SUBJECT_KEY = {
    KOR: 'kor',
    MATH: 'math',
    EN: 'en',
    PREPARE: 'prepare',
    CHOICE: 'choice',
} as const;

export type SubjectKey = ValueOf<typeof SUBJECT_KEY>;

type SubjectContent = {
    prefix: string;
    imgCount: number;
    title: string;
    description?: string;
    metaImage?: string;
    nextButton?: {
        imageUrl: string;
        to: string;
    };
    backgroundColors: string[];
    modifiedInfoList?: {
        modifiedDate: string;
        modifiedIndexList: number[];
    }[];
    skipContents?: number[];
    aniImgValues?: { index: number; url: string; className: string }[];
};

export const subjectContents: Record<SubjectKey, SubjectContent> = {
    [SUBJECT_KEY.KOR]: {
        prefix: `${PREFIX}/kor/content`,
        imgCount: 10,
        title: '윙크 수준별 한글·국어',
        description: '수준별 한글·국어 더 알아보기',
        metaImage: 'https://s.wink.co.kr/images/common/meta_subject_kor.png',
        nextButton: {
            imageUrl:
                'https://s.wink.co.kr/pc/renewalV2/subject/kor/next_button.png',
            to: '/subject/math',
        },
        skipContents: [4],
        backgroundColors: [
            '#ffffff',
            '#ffd8b9',
            '#ffffff',
            '#ffffff',
            '#019fe0',
            '#f1f1f2',
            '#ffffff',
            '#00a1e3',
            '#fde9f1',
            '#ddeefa',
        ],
        modifiedInfoList: [
            {
                modifiedDate: '260428',
                modifiedIndexList: [1],
            },
            {
                modifiedDate: '260414',
                modifiedIndexList: [8],
            },
            {
                modifiedDate: '240820',
                modifiedIndexList: [2, 3, 9, 10],
            },
            {
                modifiedDate: '230621',
                modifiedIndexList: [6],
            },
            {
                modifiedDate: '211201',
                modifiedIndexList: [6],
            },
        ],
    },
    [SUBJECT_KEY.MATH]: {
        prefix: `${PREFIX}/math/content`,
        imgCount: 10,
        title: '윙크 수준별 수학·연산',
        description: '수준별 수학·연산 더 알아보기',
        metaImage: 'https://s.wink.co.kr/images/common/meta_subject_math.png',
        nextButton: {
            imageUrl:
                'https://s.wink.co.kr/pc/renewalV2/subject/math/next_button.png',
            to: '/subject/en',
        },
        skipContents: [4],

        backgroundColors: [
            '#ffffff',
            '#beebff',
            '#ffffff',
            '#ffffff',
            '#019fe0',
            '#f1f1f2',
            '#ffffff',
            '#019fe0',
            '#fde9f1',
            '#e1eef9',
        ],
        modifiedInfoList: [
            {
                modifiedDate: '260428',
                modifiedIndexList: [1],
            },
            {
                modifiedDate: '240820',
                modifiedIndexList: [2, 3, 9, 10],
            },
            {
                modifiedDate: '230621',
                modifiedIndexList: [6],
            },
            {
                modifiedDate: '221228',
                modifiedIndexList: [1],
            },
        ],
    },
    [SUBJECT_KEY.EN]: {
        prefix: `${PREFIX}/eng/content`,
        imgCount: 9,
        title: '윙크 수준별 영어&파닉스',
        description: '수준별 영어&파닉스 더 알아보기',
        metaImage: 'https://s.wink.co.kr/images/common/meta_subject_eng.png',
        nextButton: {
            imageUrl:
                'https://s.wink.co.kr/pc/renewalV3/subject/eng/next_button_240820.png',
            to: '/subject/prepare',
        },
        backgroundColors: [
            '#FFFFFF',
            '#ffc5df',
            '#f6f6f6',
            '#ffffff',
            '#019fe0',
            '#f1f1f2',
            '#019fe0',
            '#fde9f1',
            '#e1eef9',
        ],
        modifiedInfoList: [
            {
                modifiedDate: '260428',
                modifiedIndexList: [1],
            },
            {
                modifiedDate: '240820',
                modifiedIndexList: [2, 8],
            },
        ],
    },
    [SUBJECT_KEY.PREPARE]: {
        prefix: `${PREFIX}/prepare/content`,
        imgCount: 6,
        title: '초등교과(캐츠홈)',
        description:
            '윙크 회원이라면 초등 전문학습 캐츠홈을 함께 이용할 수 있습니다. 초등 수학·국어·사회·과학부터 학교시험 대비와 교과 전문 선생님의 맞춤 관리까지 알아보세요.',
        metaImage: 'https://s.wink.co.kr/images/common/meta_subject_school.png',
        nextButton: {
            imageUrl:
                'https://s.wink.co.kr/pc/renewalV3/subject/prepare/next_button_240820.png',
            to: '/subject/choice',
        },
        backgroundColors: [
            '#f4f5f7',
            '#c1e2ff',
            '#FFFFFF',
            '#78b0ff',
            '#fff0b9',
            '#ffffff',
        ],
        modifiedInfoList: [
            {
                modifiedDate: '240820',
                modifiedIndexList: [1, 2, 3, 4, 5, 6],
            },
        ],
    },
    [SUBJECT_KEY.CHOICE]: {
        prefix: `${PREFIX}/choice/content`,
        imgCount: 11,
        skipContents: [4, 5, 6],
        title: '윙크 선택활동(배경지식&한자)',
        description: '배경지식&한자 더 알아보기',
        metaImage: 'https://s.wink.co.kr/images/common/meta_subject_choice.png',
        backgroundColors: [
            '#EEEDEB',
            '#e7cdff',
            '#ffffff',
            '#eff1f3',
            '#f7b7d3',
            '#ffffff',
            '#A24DEB',
            '#ffffff',
            '#F6F6F6',
            '#ffffff',
            '#f0e0ff',
        ],
        modifiedInfoList: [
            {
                modifiedDate: '260428',
                modifiedIndexList: [1],
            },
            {
                modifiedDate: '240820',
                modifiedIndexList: [2],
            },
            {
                modifiedDate: '230621',
                modifiedIndexList: [3],
            },
        ],
    },
};
